module.exports = __webpack_public_path__ + "img/16.6aeb5973.jpg";